import authService from './authService';

const BASE_URL = process.env.REACT_APP_API_URL;

export async function getInstitutions(query:string, perPage:number, pageNo:number) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/tenant?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
      });

     // console.log(response);

      if (!response.ok) {
        throw new Error('Failed to get institutions');
      }

      const result = await response.json();
     // console.log('Institutions fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching institutions:', error);
      throw new Error('Error fetching institutions');
    }
}


export async function createAnnouncement(data: any) {
  try {
      const response = await authService.apiCall(`${BASE_URL}/announcements`, {
          method: 'POST',
      
          body: JSON.stringify(data)
      });
      if (!response.ok) {
          throw new Error('Failed to create announcement');
      }
      const result = await response.json();
      return result;
  } catch (error: any) {
      console.error('Error creating announcement:', error);
      throw new Error('Error creating announcement');
  }
}

export async function uploadFile(data:any) {
  try {
      const response = await authService.apiCall(`${BASE_URL}/upload/announcement-files`, {
          method: 'POST',
        
          body: data
      });
      return response;
  } catch (error: any) {
      console.error('Error uploading file:', error);
      throw new Error('Error uploading file');
  }
}


export async function getAnnouncement(query:string, perPage:number, pageNo:number) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/announcements?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error('Failed to get announcement');
      }

      const result = await response.json();
     // console.log('Announcement fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching announcement:', error);
        throw new Error('Error fetching announcement');
    }
}